/* Almla redesign: product page behaviour. Gallery dots and counter, sticky add
   bar and rail arrows are ported from the Cortex Page Builder product design.
   Quantity, variant choice and every add button go through the real Shopify
   cart via the product form and window.AlmCart. Adds two rails the design
   showed as static samples: "Same color, other styles" (matched on the curated
   facet colours) and "Recently viewed" (kept in this browser only). */
(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var esc = function (s) {
    return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
    });
  };
  var PDP = window.ALM_PDP || {};
  var form = $("#almProductForm");

  /* ---- Quantity: the visible counter drives the form's hidden quantity ---- */
  var qty = 1;
  $$("[data-q]", $("#atcRow")).forEach(function (b) {
    b.addEventListener("click", function () {
      qty = Math.max(1, qty + +b.getAttribute("data-q"));
      $("#pQty").textContent = qty;
      var input = $("[data-qty-input]"); if (input) input.value = qty;
    });
  });

  /* ---- Variants: map the option selects to a variant id ---- */
  var vjson = $("[data-variants]");
  if (vjson && form) {
    var variants = [];
    try { variants = JSON.parse(vjson.textContent); } catch (e) {}
    var selects = $$(".size-select", form);
    var money = function (cents) { var v = cents / 100; return "$" + v.toLocaleString("en-US", { minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 }); };
    var pick = function () {
      var chosen = selects.map(function (s) { return s.value; });
      var v = variants.filter(function (x) { return x.options.every(function (o, i) { return o === chosen[i]; }); })[0];
      var btn = $("#atcBtn"), sbtn = $("#sbarBtn");
      if (!v) {
        btn.disabled = true; btn.textContent = "Unavailable";
        if (sbtn) { sbtn.disabled = true; sbtn.textContent = "Unavailable"; }
        return;
      }
      $("[data-variant-input]", form).value = v.id;
      $("#pPrice").textContent = money(v.price);
      var sp = $("#sbarPrice"); if (sp) sp.textContent = money(v.price);
      btn.disabled = !v.available;
      btn.innerHTML = v.available ? 'Add to Cart <span aria-hidden="true">&middot;</span> <span id="atcPrice">' + money(v.price) + "</span>" : "Sold out";
      if (sbtn) { sbtn.disabled = !v.available; sbtn.textContent = v.available ? "Add to Cart" : "Sold out"; }
      if (history.replaceState) {
        var u = new URL(location.href); u.searchParams.set("variant", v.id); history.replaceState(null, "", u);
      }
    };
    selects.forEach(function (s) { s.addEventListener("change", pick); });
  }

  /* ---- One-tap adds (upsell rows and rail cards) ---- */
  document.addEventListener("click", function (e) {
    var a = e.target.closest("[data-add-variant]");
    if (!a || !window.AlmCart) return;
    e.preventDefault();
    a.disabled = true;
    var props = a.hasAttribute("data-rb") && window.AlmRebuy ? AlmRebuy.props("Product Others You May Like") : null;
    AlmCart.add(a.getAttribute("data-add-variant"), 1, false, props).then(function () { a.disabled = false; });
  });

  /* ---- Others you may like (client feedback, Oct 13). The server renders
     the candidates in order: theme styles (data-k="t": this product's own
     style group collections, same kind), the upsell collection (f), the
     other kind (o); the first three show. With Rebuy (alm-rebuy.js) the
     theme styles are ranked by Rebuy's picks for this product, then its top
     sellers, and Rebuy's own picks fill in after them, ahead of the upsell
     collection. If Rebuy is slow the server's three stay. More from this
     collection gives way to this box, and upsReady resolves with the handles
     it shows so the rows below can skip them too. ---- */
  var cardHandle = function (el) { try { return JSON.parse(el.getAttribute("data-alm")).h; } catch (e) { return ""; } };
  var ups = document.querySelector("[data-rebuy-ups]");
  var upsHandles = function () { return ups ? $$(".ups[data-h]:not([hidden])", ups).map(function (r) { return r.getAttribute("data-h"); }) : []; };
  var settled = false;
  function settle() {
    if (settled) return upsHandles();
    settled = true;
    if (ups) $$(".ups[hidden]", ups).forEach(function (r) { r.remove(); });
    var mine = {};
    upsHandles().forEach(function (h) { mine[h] = 1; });
    var col = $("[data-col-rail]");
    if (col) {
      var n = 0;
      $$(".cardwrap[data-alm]:not([data-col-spare])", col).forEach(function (c) {
        if (mine[cardHandle(c)] || n >= 12) c.remove();
        else { c.hidden = false; n++; }
      });
      // Fewer than three left: top up from Shop All and rename the row.
      var spares = $$("[data-col-spare]", col);
      if (n < 3) {
        spares.forEach(function (c) {
          if (mine[cardHandle(c)] || n >= 10) c.remove();
          else { c.hidden = false; c.removeAttribute("data-col-spare"); n++; }
        });
        var h = $("[data-col-h]", col), lab = $("[data-col-lab]", col), all = $(".rail-all", col);
        if (h) h.textContent = "More to love";
        if (lab) lab.textContent = "Shop All";
        if (all) { all.href = "/collections/shop-all"; all.innerHTML = "Shop all"; }
      } else spares.forEach(function (c) { c.remove(); });
      col.hidden = !n;
    }
    return upsHandles();
  }
  var upsReady;
  if (ups && window.AlmRebuy) {
    var pid = ups.getAttribute("data-rebuy-ups"), acc = ups.hasAttribute("data-acc");
    var recQ = { shopify_product_ids: pid, limit: 16 };
    var none = function () { return []; };
    var rb = Promise.all([AlmRebuy.handles("products/recommended", recQ).catch(none), AlmRebuy.handles("products/top_sellers", { limit: 60 }).catch(none)]).then(function (r) {
      if (settled) return;
      var pos = {};
      r[0].forEach(function (h, i) { if (!(h in pos)) pos[h] = i; });
      r[1].forEach(function (h, i) { if (!(h in pos)) pos[h] = 100 + i; });
      var rows = $$(".ups[data-h]", ups);
      var rank = function (row, i) { var h = row.getAttribute("data-h"); return h in pos ? pos[h] : 1000 + i; };
      var theme = rows.filter(function (row) { return row.getAttribute("data-k") === "t"; })
        .map(function (row, i) { return { row: row, r: rank(row, i) }; })
        .sort(function (a, b) { return a.r - b.r; }).map(function (x) { return x.row; });
      var rest = rows.filter(function (row) { return theme.indexOf(row) < 0; });
      var need = 3 - theme.length;
      var extra = need > 0
        ? AlmRebuy.cards("products/recommended", recQ, { limit: need, pool: 12, socksOnly: !acc, exclude: [ups.getAttribute("data-handle")].concat(rows.map(function (row) { return row.getAttribute("data-h"); })) }).catch(none)
        : Promise.resolve([]);
      return extra.then(function (list) {
        if (settled) return;
        var wrap = document.createElement("div");
        wrap.innerHTML = list.map(function (p) {
          return '<div class="ups" data-h="' + esc(p.h) + '" data-k="r">' + (p.i ? '<img src="' + esc(p.i) + '" alt="" loading="lazy">' : "") +
            '<div class="ups-t"><a href="' + esc(p.u) + '">' + esc(p.t) + "</a><span>" + esc(p.f) + "</span></div>" +
            '<button type="button" class="ups-add" data-add-variant="' + esc(p.v) + '" data-rb aria-label="Add ' + esc(p.t) + ' to cart">+</button></div>';
        }).join("");
        theme.concat([].slice.call(wrap.children), rest).forEach(function (row, i) {
          row.hidden = i >= 3;
          ups.appendChild(row);
        });
      });
    }).then(settle, settle);
    // A slow Rebuy answer never holds the rows below back for long.
    upsReady = Promise.race([rb, new Promise(function (r) { setTimeout(function () { r(settle()); }, 3500); })]);
  } else {
    upsReady = Promise.resolve(settle());
  }

  /* ---- Mobile gallery dots + counter ---- */
  var grid = $("#galGrid"), dots = $("#gDots");
  if (grid && dots) {
    var imgs = $$(".gimg", grid);
    imgs.forEach(function (_, i) { var d = document.createElement("i"); if (!i) d.className = "is-on"; dots.appendChild(d); });
    grid.addEventListener("scroll", function () {
      var i = Math.round(grid.scrollLeft / Math.max(1, grid.clientWidth));
      $$("i", dots).forEach(function (d, j) { d.classList.toggle("is-on", j === i); });
      $("#gCount").textContent = (i + 1) + " / " + imgs.length;
    }, { passive: true });
  }

  /* ---- Sticky add bar once the main button scrolls away ---- */
  var sbar = $("#sbar"), atcRow = $("#atcRow"), ticking = false;
  function barCheck() {
    ticking = false;
    if (!sbar || !atcRow) return;
    var on = atcRow.getBoundingClientRect().bottom < 0 && !document.documentElement.classList.contains("acd-open");
    sbar.classList.toggle("is-on", on);
    // Floating app widgets (Klaviyo, Wishlist, accessibility) step above the bar.
    document.documentElement.classList.toggle("alm-sbar-on", on && window.matchMedia("(max-width:900px)").matches);
    sbar.setAttribute("aria-hidden", on ? "false" : "true");
  }
  window.addEventListener("scroll", function () { if (!ticking) { ticking = true; requestAnimationFrame(barCheck); } }, { passive: true });

  /* ---- Rail arrows ---- */
  function wireRail(r) {
    var t = $("[data-rail]", r), p = $("[data-rail-prev]", r), n = $("[data-rail-next]", r);
    if (!t) return;
    if (p) p.addEventListener("click", function () { t.scrollBy({ left: -t.clientWidth * 0.8, behavior: "smooth" }); });
    if (n) n.addEventListener("click", function () { t.scrollBy({ left: t.clientWidth * 0.8, behavior: "smooth" }); });
  }
  $$(".rail").forEach(wireRail);

  /* ---- Same color, other styles: the server renders only colour matches
     (in stock, not in row 1, not the current product); this drops any that
     "Others you may like" shows and keeps ten. ---- */
  var shownH = {};
  if (PDP.handle) shownH[PDP.handle] = 1;
  var sameColor = upsReady.then(function (uh) {
    (uh || []).forEach(function (h) { shownH[h] = 1; });
    $$("[data-col-rail] .cardwrap[data-alm]").forEach(function (c) { shownH[cardHandle(c)] = 1; });
    var rail = $("[data-same-color]");
    if (!rail) return;
    var F = window.ALM_FACETS || {}, COLORS = window.ALM_COLORS || [];
    var MERGE = { white: "cream", peach: "orange", navy: "blue" }; // same merge as the collection filters
    var mine = PDP.color || (F[PDP.handle] || {}).c;
    mine = MERGE[mine] || mine;
    var pool = $$("[data-pool]", rail).filter(function (card) { return !shownH[card.getAttribute("data-pool")]; }).slice(0, 10);
    var spares = $$("[data-color-spare]", rail);
    if (pool.length >= 3) {
      $$("[data-pool]", rail).forEach(function (card) { if (pool.indexOf(card) < 0) card.remove(); });
      pool.forEach(function (card) { card.hidden = false; shownH[card.getAttribute("data-pool")] = 1; });
      spares.forEach(function (c) { c.remove(); });
      var name = (COLORS.filter(function (c) { return c[0] === mine; })[0] || [0, ""])[1];
      var lab = $("[data-color-name]", rail); if (lab) lab.textContent = name;
      rail.hidden = false;
      return;
    }
    // Fewer than three in this colour (client, Oct 15: three rows on every
    // product page): New Arrivals the rows above don't already show.
    $$("[data-pool]", rail).forEach(function (card) { card.remove(); });
    var kept = 0;
    spares.forEach(function (c) {
      var h = cardHandle(c);
      if (kept < 10 && !shownH[h]) { c.hidden = false; c.removeAttribute("data-color-spare"); shownH[h] = 1; kept++; }
      else c.remove();
    });
    if (kept < 3) return;
    var lab2 = $("[data-color-name]", rail); if (lab2) lab2.textContent = "Just in";
    var h2 = $("#r-clr", rail); if (h2) h2.textContent = "New arrivals";
    var all = $(".rail-all", rail); if (all) all.href = "/collections/new-arrivals-1";
    rail.hidden = false;
  });

  /* ---- Recently viewed (this browser only). Sold-out styles, gift cards,
     hats and totes (z) are left out, and so is anything the rows above
     already show, unless that would leave the row with fewer than two. ---- */
  (function () {
    var KEY = "alm_recent", list = [];
    try { list = JSON.parse(localStorage.getItem(KEY) || "[]"); } catch (e) { list = []; }
    if (!Array.isArray(list)) list = [];
    var me = PDP.recent;
    var others = list.filter(function (x) { return x && me && x.h !== me.h; }).slice(0, 10);
    if (me) {
      try { localStorage.setItem(KEY, JSON.stringify([me].concat(others).slice(0, 12))); } catch (e) {}
    }
    var rail = $("[data-recent]");
    others = others.filter(function (x) { return !x.s && !x.z && x.v && !/gift-card/.test(x.h); });
    if (!rail) return;
    if (!others.length) {
      // No history yet: Best Sellers the rows above don't already show.
      sameColor.then(function () {
        var kept = 0;
        $$("[data-pool]", rail).forEach(function (card) {
          var h = card.getAttribute("data-pool");
          if (kept < 10 && !shownH[h]) { card.hidden = false; kept++; } else card.remove();
        });
        if (kept < 3) return;
        $("[data-recent-lab]", rail).textContent = "Popular";
        $("[data-recent-h]", rail).textContent = "Best sellers";
        rail.hidden = false;
      });
      return;
    }
    // alm-cards.js loads after this file (both deferred), so draw once the
    // page's scripts have all run.
    function draw() {
      var fresh = others.filter(function (x) { return !shownH[x.h]; });
      var show = fresh.length >= 2 ? fresh : others;
      $("[data-rail]", rail).innerHTML = show.map(function (x) {
        // Saved before the Shop All card came to this page: price was text only.
        if (!x.f) { x.f = x.p; x.p = 0; }
        return AlmCards.html(x);
      }).join("");
      AlmCards.scan();
      rail.hidden = false;
    }
    var ready = new Promise(function (r) {
      if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", r); else r();
    });
    Promise.all([ready, sameColor]).then(function () { if (window.AlmCards) draw(); });
  })();
})();
